export default __webpack_public_path__ + "static/help_06_02-2-beecf4922431e11a69d2b01c980a6aff.png";